import { render, staticRenderFns } from "./LandingDetecteurs.vue?vue&type=template&id=b22e6c40&scoped=true"
import script from "./LandingDetecteurs.vue?vue&type=script&lang=js"
export * from "./LandingDetecteurs.vue?vue&type=script&lang=js"
import style0 from "./LandingDetecteurs.vue?vue&type=style&index=0&id=b22e6c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22e6c40",
  null
  
)

export default component.exports